export const buildCreateShadowProfileBody = (
    firstName: string,
    lastName: string,
    email: string,
    roleId?: string,
    resourceChildId?: string,
    resourceType?: string
) => ({
    shadowProfile: {
        firstName,
        lastName,
        email
    },
    profilePrivileges: roleId
        ? {
            resourceType,
            resourceChildId,
            roleId
        }
        // tslint:disable-next-line:no-null-keyword
        : null
});
